import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CDropdownItem,
  CFormCheck,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
} from '@coreui/react-pro'
import React, { useCallback, useEffect, useState } from 'react'
import DynamicSection from './DynamicSection'
import './ProgressNote.scss'
import DynamicSectionFilter from './DynamicSectionFilter'
import DynamicTemplates from './DynamicTemplates'
import { useDispatch, useSelector } from 'react-redux'
import {
  changeMIPSdata,
  onFirstNoteLoad,
  onTemplateValueSet,
  overwriteVisitDetails,
  resetProgressNote,
  setActiveSection,
  setCheckCareCoordination,
  setProcedureCode,
  setSelectedSections,
  setSelectedTemplate,
  setTurnDragonOff,
  updateChartErrors,
} from 'src/redux/progressNote/progressNoteSlice'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getAiPredictions, getInitialPayload } from 'src/redux/progressNote/progressNoteThunk'
import Loader from 'src/components/common/Loader/Loader'
import SnippetSection from './SnippetSection'
import {
  chartArrayGenerater,
  createTemplateWithValue,
  isNoteValide,
  mergeTwoTemplate,
} from 'src/helper/formater'
import {
  billVisitSubmit,
  getMySnippets,
  submitDiagCodes,
  putProgressNoteProcedures,
  removeThisSnippets,
  saveChartProgressNote,
  saveMIPSData,
  signChartProgressNote,
  changeTeleHealth,
  changeCareCoordination,
  changeLongTermCare,
  changeHospiceRelated,
  changeSharedServiceProvider,
  updateCareTeam,
  saveBillingNotes,
  updateVisitFields,
  getProgressNoteImage,
} from 'src/helper/backendHelper'
import { toast } from 'react-toastify'
import { getBetaVisitStatus, getFacilities } from 'src/redux/census/censusThunk'
import BillingSummary from './BillingSummary'
import SherpaAI from './SherpaAI'
import BillingSummaryDisabled from './BillingSummaryDisabled'
import { updateCPTWithFSModifier } from '../../../components/common/shared/sharedCPTLogic'
import { fetchMips } from '../../../helper/mipsHelper'
import { dateUSFormat } from '../../../utils/dateTimeUtils'
import { STATUS_GROUPS, VISIT_STATUS } from '../../../utils/statusConstants'
import { COLLECTOR_URL } from '../../../apiHelper/apiRoute/collector'
import { putCollector } from '../../../apiHelper/collectorApi'
import _ from 'lodash'
import { getAge, goBackNavigation } from '../../../utils/sharedFunctions'
import DragonController from './DragonController'
import ProgressNoteActionButtons from './ProgressNoteActionButtons'
import { TAB_OPTIONS } from './progressNoteConstants'
import RecentNoteSection from './RecentNoteSection'
import { getIsAi, showLongTermCare } from '../../../utils/sharedFeaturesFunctions'
import AsteriskConfirm from '../census/components/ConfirmationModals/AsteriskConfirm'
import { doesNoteHaveAsterisks } from '../../../utils/sharedChartFunctions'
import FEATURES from '../../../utils/featuresConstants'
import { shouldShowAsteriskWarning } from '../../../redux/user/userSlice'
import { format } from 'date-fns'
import GenericConfirmModal from '../census/components/ConfirmationModals/GenericConfirmModal'
import {
  billVisitErrorCheck,
  isChargeSigned,
} from '../../../components/common/shared/sharedEncounterLogic'
import { getChartValidations } from '../../../helper/chartValidationHelper'
import LabPreview from './LabPreview'
import { ENCOUNTER_TYPES } from '../sharedConstants'

// combine toasts since they are all small on legacy
function brToastSuccess(msg, { style } = {}) {
  toast.success(msg, {
    position: 'bottom-right',
    ...(style ? { style: style } : {}),
  })
}

function brToastError(msg) {
  toast.error(msg, {
    position: 'bottom-right',
  })
}

function findErrorMsg(e) {
  return (
    e?.response?.data?.message ||
    e?.response?.data?.error ||
    e?.response?.data?.result ||
    e?.message ||
    e?.result
  )
}

export default function ProgressNote() {
  const quary = useParams()
  const previousState = useLocation()

  const dispatch = useDispatch()
  const navigate = useNavigate()

  // note state selectors
  const visitDetails = useSelector((state) => state.progressNote.visitDetails)
  const selectedTemplate = useSelector((state) => state.progressNote?.selectedTemplate)
  const templateData = useSelector((state) => state.progressNote?.selectedTemplate?.data)
  const selectedSections = useSelector((state) => state.progressNote?.selectedSections)
  const procedureCodesSelected = useSelector((state) => state?.progressNote?.procedureCodesSelected)
  const diagnosisCodesSelected = useSelector((state) => state?.progressNote?.diagnosisCodesSelected)
  const activeSection = useSelector((state) => state.progressNote.activeSection)
  const isloading = useSelector((state) => state.progressNote.isloading)
  const isInputDisable = useSelector((state) => state.progressNote.isInputDisable)
  const callSaveDraft = useSelector((state) => state.progressNote?.isSaveDraft)

  const visitStatuses = useSelector((state) => state.census?.visitStatuses) || {}
  const allFacilities = useSelector((state) => state.census?.allFacilitiesList)

  const asteriskIgnorePeriodExpired = useSelector(shouldShowAsteriskWarning)
  const provider = useSelector((state) => state?.user?.provider)
  const practice = useSelector((state) => state?.user?.practice)
  const roles = useSelector((state) => state?.user?.roles) || []
  const features = useSelector((state) => state?.user?.features)
  const canUseDragon = features?.includes(FEATURES.Dragon)

  const [mainTab, setMainTab] = useState(1)
  const [backConfirm, setBackConfirm] = useState(false)
  const [showAsteriskWarningModal, setShowAsteriskWarningModal] = useState(false)

  const [billingEntity, setBillingEntity] = useState()
  const [dateOfService, setDateOfService] = useState(format(new Date(), 'yyyy-MM-dd'))
  const [changedDOS, setChangedDOS] = useState(false)
  const [selectedFacilityID, setSelectedFacilityID] = useState(null)
  const [selectedFacilityName, setSelectedFacilityName] = useState(null)
  const [selectedPlaceOfService, setSelectedPlaceOfService] = useState(null)
  const [selectedSharedProvider, setSelectedSharedProvider] = useState(null)
  const [incidentToProviderSubstantive, setIncidentToProviderSubstantive] = useState(false)
  const [encounterType, setEncounterType] = useState(ENCOUNTER_TYPES.INITIAL)
  const [isHospiceRelated, setIsHospiceRelated] = useState(false)
  const [isTelehealth, setIsTelehealth] = useState(false)
  const [isCareCoordination, setIsCareCoordination] = useState(false)
  const [isLongTermCare, setIsLongTermCare] = useState(false)
  const [careTeam, setCareTeam] = useState(null)
  const [isNeuroSuite, setIsNeuroSuite] = useState(false)
  const [isPendingCosign, setIsPendingCosign] = useState(false)
  const [authNumber, setAuthNumber] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isFirstAutoFocusSave, setIsFirstAutoFocusSave] = useState(true)

  const [noteStateInitialLoad, setNoteStateInitialLoad] = useState(false)
  // Fun fact, Procedure codes were relying on the note state refresh to update the page
  // so be aware of that as we ditch state for something more logical
  useEffect(() => {
    if (!isloading && !noteStateInitialLoad) {
      setNoteStateInitialLoad(true)
      setSelectedPlaceOfService(visitDetails?.place_of_service || '')
      setBillingEntity(
        visitDetails?.legal_entity_id
          ? { legal_entity_id: visitDetails.legal_entity_id }
          : provider?.legal_entities?.length > 0
            ? provider.legal_entities[0]
            : null,
      )
      setIsTelehealth(visitDetails?.telehealth)
      setIsCareCoordination(visitDetails?.care_coordination)
      setIsLongTermCare(visitDetails?.long_term_care)
      setCareTeam(visitDetails?.careteam)
      setIsHospiceRelated(visitDetails?.hospice_related)
      setIsNeuroSuite(visitDetails?.neuro_suite)
      setIsPendingCosign(visitDetails?.pending_cosign)
      setAuthNumber(visitDetails?.auth_number)
      // shouldn't these be on visit and not patient?
      setSelectedSharedProvider(visitDetails?.incident_to_provider_id)
      setIncidentToProviderSubstantive(visitDetails?.incident_to_provider_substantive)

      if (visitDetails?.encounterType) {
        setEncounterType(visitDetails.encounterType)
      }

      if (visitDetails) {
        setBillingTxt(visitDetails?.code_assist?.billing_notes || '')
      }

      if (visitDetails?.service_date_from) {
        setDateOfService(visitDetails?.service_date_from)
      }

      if (visitDetails?.facility_id) {
        setSelectedFacilityID(visitDetails?.facility_id)
      }

      if (visitDetails?.facility_name) {
        setSelectedFacilityName(visitDetails?.facility_name)
      }
    }
  }, [provider?.legal_entities, isloading, visitDetails, noteStateInitialLoad])

  useEffect(() => {
    updateCPTWithFSModifier(selectedSharedProvider, procedureCodesSelected, (newCPTs) =>
      dispatch(setProcedureCode(newCPTs)),
    )
  }, [dispatch, selectedSharedProvider, procedureCodesSelected])

  const [snippetList, setSnippetList] = useState()

  const [removedSection, setRemovedSection] = useState([])

  const [isDraftSaved, setIsDraftSaved] = useState(false)

  const [billingTxt, setBillingTxt] = useState('')
  const [isTyping, setIsTyping] = useState(true)

  useEffect(() => {
    if (allFacilities?.length < 1) {
      dispatch(getFacilities())
    }
  }, [dispatch, allFacilities])

  useEffect(() => {
    if (quary?.id) {
      dispatch(getInitialPayload(quary.id))
      dispatch(getBetaVisitStatus())
      getSnips()

      // added back in so that we can generate note images for these draft notes
      // so they can be downloaded, albeit improperly
      getProgressNoteImage(quary.id, 'progNoteLoad')
    }
    return () => {
      // move to initial call?
      dispatch(resetProgressNote())
    }
  }, [dispatch, quary?.id])

  const getSnips = (sortFunction = (data) => data) => {
    getMySnippets().then((res) => {
      if (res?.status === 'success') {
        setSnippetList(sortFunction(res?.results))
      }
    })
  }

  const [currentTab, setCurrentTab] = useState(TAB_OPTIONS.SECTION)

  useEffect(() => {
    if (noteStateInitialLoad) {
      dispatch(setCheckCareCoordination(isCareCoordination))
    }
  }, [dispatch, isCareCoordination, noteStateInitialLoad])

  // if there are MIPS on the visit, use this logic to auto check the MIPS section
  const [autoCheckMIPS, setAutoCheckMIPS] = useState(false)
  const [alreadyPreCheckedMips, setAlreadyPreCheckedMips] = useState(false)
  useEffect(() => {
    if (autoCheckMIPS && !alreadyPreCheckedMips) {
      setAlreadyPreCheckedMips(true)
      let mipsSection = templateData?.find((sec) => sec?.title === 'MIPS')
      if (mipsSection) {
        addSelectedSection(mipsSection)
      }
    }
  }, [templateData, autoCheckMIPS, alreadyPreCheckedMips])

  const fetchMipsCallback = useCallback(
    _.debounce((mipsData) => {
      fetchMips(mipsData).then((mips) => {
        if (mips) {
          dispatch(changeMIPSdata(mips))
          setAutoCheckMIPS(mips.length > 0)
        }
      })
    }, 750),
    [],
  )

  const CPTcodes = procedureCodesSelected.map((cpt) => cpt.code).join()
  useEffect(() => {
    let charge_id = quary?.id
    if (!charge_id || !templateData?.find((item) => item?.title === 'MIPS')) {
      return
    }

    fetchMipsCallback({
      practice_id: practice?._id,
      charge_id: charge_id,
      patient: {
        id: visitDetails?.patient_id,
        dob: visitDetails?.patient_dob,
        gender: visitDetails?.gender,
        hospiceEnrolled: Boolean(visitDetails?.patient_hospiceEnrolled),
      },
      procedures: procedureCodesSelected?.map((proc) => ({
        code: proc.code + '' || '',
        modifiers: proc.modifiers,
        units: proc?.units,
      })),
      diagnoses: diagnosisCodesSelected?.map((item) => ({ code: item.code })),
      telehealth: isTelehealth,
      place_of_service: {
        code: selectedPlaceOfService,
      },
      service_date_from: dateOfService,
    })
  }, [
    // wow so many things to trigger MIPS refresh
    dispatch,
    practice?._id,
    quary?.id,
    // commenting this one out, because it will cause infinite re renders
    // templateData,
    visitDetails?.gender,
    visitDetails?.patient_id,
    visitDetails?.patient_dob,
    visitDetails?.patient_hospiceEnrolled,
    diagnosisCodesSelected,
    // procedureCodesSelected,
    // using CPT code instead to prevent modifier misfires
    CPTcodes,
    isTelehealth,
    selectedPlaceOfService,
    fetchMipsCallback,
    dateOfService,
  ])

  const [isValidToSign, setIsValidToSign] = useState(false)
  useEffect(() => {
    setIsValidToSign(!(procedureCodesSelected?.length < 1 || diagnosisCodesSelected?.length < 1))
  }, [procedureCodesSelected, diagnosisCodesSelected])

  useEffect(() => {
    let isMounted = true

    async function update(sec) {
      let txtValue = chartArrayGenerater(sec)
      if (isMounted) {
        await dispatch(onTemplateValueSet(txtValue))
      }
    }

    if (!isTyping) {
      if (currentTab === TAB_OPTIONS.TEMPLATE) {
        let currentSection = templateData?.find((sec) => {
          if (sec?.title === activeSection?.title && !sec?.ignoreTemplateTab) {
            if (sec?.sections?.length > 0) {
              if (
                !(sec?.title === 'Diagnosis (ICD10)' || sec?.title === 'E&M and procedure codes')
              ) {
                return true
              }
            }
          }
          return false
        })
        if (currentSection) {
          update(currentSection)
        }
      }
    }

    return () => {
      isMounted = false
    }
  }, [dispatch, templateData, activeSection, isTyping, currentTab])

  useEffect(() => {
    if (templateData && selectedSections?.length < 1) {
      let mandatorySections = templateData?.filter(
        (section) => !section?.optional || section?.skip === false,
      )

      // pulled this out so that skipped sections don't get forced to appear
      if (mandatorySections.length === 0) {
        mandatorySections = templateData?.filter((section) => section?.values)
      }

      // if we STILL have no mandatory sections, select all
      // no sections means infinite rerenders
      if (mandatorySections.length === 0) {
        mandatorySections = templateData
      }

      // update the empty note with the valid selected sections
      // (and eventually try to update the left side so its up to date with current dx codes)
      dispatch(onFirstNoteLoad(mandatorySections))
    }
  }, [dispatch, templateData, selectedSections])

  const shouldUpdateChartInfo = !isloading && !isInputDisable
  useEffect(() => {
    if (shouldUpdateChartInfo && mainTab === 2 && quary?.id && procedureCodesSelected.length > 0) {
      let procedures = procedureCodesSelected.map((item) => ({
        code: item?.code,
        modifiers: item?.modifiers || [],
        units: item?.units,
      }))
      putProgressNoteProcedures(quary.id, {
        procedures: procedures?.filter((item) => item?.code),
      })
    }
  }, [shouldUpdateChartInfo, quary?.id, procedureCodesSelected, mainTab])

  useEffect(() => {
    if (shouldUpdateChartInfo && quary?.id && diagnosisCodesSelected.length > 0) {
      let diagnosis_codes = diagnosisCodesSelected.map((item) => item?.code)
      submitDiagCodes(quary.id, { diagnosis_codes })
    }
  }, [shouldUpdateChartInfo, quary?.id, diagnosisCodesSelected])

  const addSelectedSection = (section) => {
    let isHaveSection = selectedSections.find((sSection) => sSection?.title === section?.title)

    if (!isHaveSection) {
      let inRemovedSection = removedSection?.find((item) => item?.title === section?.title)

      if (inRemovedSection) {
        let newRemovedSections = removedSection?.filter((item) => item?.title !== section?.title)
        setRemovedSection(newRemovedSections)
        dispatch(setSelectedSections([...selectedSections, { ...inRemovedSection, skip: false }]))
      } else {
        dispatch(setSelectedSections([...selectedSections, { ...section, skip: false }]))
      }
      if (section.title === 'Care Coordination') {
        setIsCareCoordination(true)
      }
      dispatch(setTurnDragonOff(true))
    }
  }

  const removeSelectedSection = (section) => {
    let thisRemovedSection = selectedSections.find((item) => item?.title === section?.title)

    if (thisRemovedSection) {
      let selectedSection = selectedSections.filter((item) => item?.title !== section?.title)

      setRemovedSection([...removedSection, { ...thisRemovedSection, skip: true }])
      dispatch(setSelectedSections(selectedSection))

      if (section.title === 'Care Coordination') {
        setIsCareCoordination(false)
      }
    }
  }

  const selectAllSection = (e) => {
    let joinedList = mergeTwoTemplate(templateData, selectedSections)

    if (e.currentTarget.checked) {
      let joinedListWithRemoved = mergeTwoTemplate(joinedList, removedSection)
      dispatch(setTurnDragonOff(true))
      dispatch(
        setSelectedSections(
          joinedListWithRemoved.map((newSection) => ({ ...newSection, skip: false })),
        ),
      )
    } else {
      let removableSections = []
      let mandatorySections = []
      joinedList.forEach((section) => {
        if (!section.optional) {
          mandatorySections.push({ ...section, skip: false })
        } else {
          removableSections.push({ ...section, skip: true })
        }
      })
      dispatch(setSelectedSections(mandatorySections))
      setRemovedSection(removableSections)
    }
  }

  const onDeleteSnippet = (id) => {
    removeThisSnippets(id).then((res) => {
      if (res?.status === 'success') {
        toast.success('Snippet removed...')
        getSnips()
      }
    })
  }

  // what does this do?
  const onTemplateFill = (data, sectionTitle) => {
    let tempList = [...selectedSections]

    const index = tempList.findIndex((item) => item.title === sectionTitle)

    let valueList = tempList[index]?.values ? [...tempList[index]?.values, data] : [data]

    tempList[index] = { ...tempList[index], values: valueList }

    dispatch(setSelectedSections(tempList))
  }

  const toggleCareCoord = (oldSection, newSection) => {
    if (oldSection && newSection) {
      const prevVal = oldSection?.sections?.[0]?.options?.[0]?.value
      const newVal = newSection?.sections?.[0]?.options?.[0]?.value
      if (prevVal !== newVal) {
        setIsCareCoordination(newVal)
      }
    }
  }

  const onDataChange = (data) => {
    dispatch(setSelectedTemplate({ ...selectedTemplate, data }))
    toggleCareCoord(
      selectedTemplate?.data?.find((sec) => sec.title === 'Care Coordination'),
      data?.find((sec) => sec.title === 'Care Coordination'),
    )
  }

  useEffect(() => {
    if (callSaveDraft) {
      onSaveDraft()
    }
  }, [callSaveDraft])

  const saveMipsIfExist = async (visitId, noteData) => {
    if (noteData?.data?.find((item) => item?.title === 'MIPS')) {
      let mips = noteData?.data
        ?.find((item) => item?.title === 'MIPS')
        ?.sections?.map((mips) => ({
          measureKey: mips?.measureKey,
          value: mips?.value,
          option_data: mips?.options?.find((item) => item?.label === mips?.value),
        }))
        ?.filter((item) => item?.value)

      await saveMIPSData(visitId, mips)
    }
  }

  // update all the encounter fields that ProgressNote/BillingSummary can edit
  const syncEncounterWithNoteChanges = async (visitId) => {
    // if no DOS, then dont do anything.
    if (!visitDetails.service_date_from) {
      return
    }
    const res = await updateVisitFields(
      visitId,
      {
        patient_id: visitDetails?.patient_id,
        service_date_from: changedDOS ? dateOfService : visitDetails.service_date_from,
        facility_id: selectedFacilityID,
        facility_name: selectedFacilityName,
        ...(selectedPlaceOfService && { place_of_service: selectedPlaceOfService }),
        neuro_suite: features?.includes(FEATURES.NeuroSuite) ? isNeuroSuite : null,
        pending_cosign: isPendingCosign,
        auth_number: authNumber,
      },
      visitDetails?.status === VISIT_STATUS.bill_submitted,
      changedDOS,
    )

    if (res?.status === 'failure') {
      console.error(res?.message)
      toast.dismiss()
      brToastError(res?.message)
      return true
    }

    // also update AdditionalInfo section so its saved on the encounter-charge
    changeTeleHealth(visitId, {
      telehealth: isTelehealth,
    })
    changeHospiceRelated(visitId, {
      hospice_related: isHospiceRelated,
    })
    changeCareCoordination(visitId, {
      carecoordination: isCareCoordination,
    })
    changeLongTermCare(visitId, {
      long_term_care: Boolean(showLongTermCare(features, selectedPlaceOfService) && isLongTermCare),
    })

    changeSharedServiceProvider(visitId, {
      incident_to_provider_id: selectedSharedProvider || null,
      incident_to_provider_substantive: incidentToProviderSubstantive,
    })
    updateCareTeam(visitId, {
      careteam: careTeam,
    })
  }

  const debounceSaveChartProgressNote = useCallback(
    _.debounce((visitId, progressPayload, noAlert, isPendingReview) => {
      saveChartProgressNote(visitId, progressPayload, 'progNote')
        .then((res) => {
          if (res?.status === 'success') {
            setIsTyping(true)

            // update with newest chart errors
            dispatch(updateChartErrors(res?.errors))

            // why do we get the image if we do nothing with it?
            // getProgressNoteImage(visitId)
            if (!noAlert) {
              toast.dismiss()
              brToastSuccess('Note Saved...', {
                style: { width: '9vw', position: 'absolute', bottom: '0', right: '0' },
              })
            }
            setIsDraftSaved(true)
            if (isPendingReview) {
              onPendingReview()
            }
          } else {
            if (!noAlert) {
              brToastError(`Unable to save draft`)
            }
          }
        })
        .catch((e) => {
          if (!noAlert) {
            brToastError(e?.response?.data?.message || 'Unable to save draft')
          }
        })
    }, 1000),
    [],
  )

  const onSaveDraft = async (noAlert = false, { isPendingReview } = {}) => {
    if (templateData && selectedSections && !isLoading) {
      let templateWithValue = createTemplateWithValue(selectedTemplate, selectedSections)

      if (quary?.id && visitDetails?.patient_id) {
        if (visitDetails?.status === VISIT_STATUS.admit) {
          const url = COLLECTOR_URL.VISIT_STATUS.replace('{visitId}', quary?.id)
          await putCollector(
            url,
            // the status we would prefer the visit to update to
            // if its in an 'unseen' state
            { status: VISIT_STATUS.checked_in },
          )
        }

        let progressPayload = {
          ...templateWithValue,
          patient_id: visitDetails.patient_id,
          encounterType: encounterType,
          initial_encounter: encounterType === ENCOUNTER_TYPES.INITIAL,
          diagnosisCodes: diagnosisCodesSelected,
          procedureCodes: procedureCodesSelected,
          from_v2: true,
          incident_to_provider_id: selectedSharedProvider,
          medical_coding: provider?.medical_coding,
          // only add to object if not null
          ...(selectedPlaceOfService && { place_of_service: selectedPlaceOfService }),
        }

        saveMipsIfExist(quary.id, templateWithValue)
        const failed = await syncEncounterWithNoteChanges(quary.id)
        if (failed) {
          return
        }
        debounceSaveChartProgressNote(quary.id, progressPayload, noAlert, isPendingReview)
      }
    }
  }

  const onSignAndBill = async ({ ignoreAsteriskWarning = false } = {}) => {
    const finalServiceDate = changedDOS ? dateOfService : visitDetails.service_date_from
    const billHasErrors = billVisitErrorCheck({
      chartValidations: await getChartValidations(),
      diagnosisCodes: diagnosisCodesSelected,
      encounterType: encounterType,
      isProgressNote: true,
      procedureCodes: procedureCodesSelected,
      practice,
      provider,
      roles,
      service_date_from: finalServiceDate,
    })

    if (billHasErrors) {
      // toasts go off in error check
      return
    }

    if (
      !ignoreAsteriskWarning &&
      asteriskIgnorePeriodExpired &&
      doesNoteHaveAsterisks(selectedSections)
    ) {
      return setShowAsteriskWarningModal(true)
    }

    if (!isNoteValide(selectedSections)) {
      brToastError('All required sections (*) must be populated')
      return
    }

    if (templateData && selectedSections) {
      let templateWithValue = createTemplateWithValue(selectedTemplate, selectedSections)
      if (quary?.id && visitDetails?.patient_id && provider) {
        if (visitDetails?.status === VISIT_STATUS.admit) {
          const url = COLLECTOR_URL.VISIT_STATUS.replace('{visitId}', quary?.id)
          await putCollector(
            url,
            // the status we would prefer the visit to update to
            // if its in an 'unseen' state
            { status: VISIT_STATUS.checked_in },
          )
        }

        await saveMipsIfExist(quary?.id, templateWithValue)
        const failed = await syncEncounterWithNoteChanges(quary?.id)
        if (failed) {
          return
        }

        try {
          // save progress note
          const progressPayload = {
            ...templateWithValue,
            patient_id: visitDetails?.patient_id,
            initial_encounter: encounterType === ENCOUNTER_TYPES.INITIAL,
            encounterType: encounterType,
            diagnosisCodes: diagnosisCodesSelected,
            procedureCodes: procedureCodesSelected,
            from_v2: true,
            incident_to_provider_id: selectedSharedProvider,
            medical_coding: provider?.medical_coding,
            // only add to object if not null
            ...(selectedPlaceOfService && { place_of_service: selectedPlaceOfService }),
          }
          const res = await saveChartProgressNote(quary.id, progressPayload, 'progNoteSign')

          if (res?.status === 'success') {
            // update with newest chart errors
            dispatch(updateChartErrors(res?.errors))

            const chargeSigned =
              isChargeSigned({
                ...visitDetails,
                statusGroup: visitStatuses[visitDetails?.status]?.group,
              }) ||
              (visitDetails.status === VISIT_STATUS.bill_pending &&
                visitDetails.rendering_provider_id === provider._id)

            // validate if we can sign the encounter-charge
            if (
              chargeSigned ||
              (new Date(dateUSFormat(finalServiceDate)) <= new Date() &&
                visitDetails?.status !== VISIT_STATUS.bill_submitted &&
                visitStatuses[visitDetails?.status]?.group !== STATUS_GROUPS.completed)
            ) {
              setIsLoading(true)
              const signBillResp = !chargeSigned
                ? await billVisitSubmit(quary.id)
                : { status: 'success' }

              if (signBillResp?.status === 'success') {
                if (!chargeSigned) {
                  brToastSuccess('Encounter Signed')
                }
                if (signBillResp?.result) {
                  dispatch(overwriteVisitDetails(signBillResp.result))
                }
                const signNoteResp = await signChartProgressNote(quary.id)

                setIsLoading(false)
                if (signNoteResp?.status === 'success') {
                  brToastSuccess('Note Signed')
                  goBackNavigation(navigate, previousState?.state?.previousPage)
                } else {
                  brToastError(findErrorMsg(signNoteResp) || 'Unable to sign Note')
                }
              } else {
                setIsLoading(false)
                let errorMsg = findErrorMsg(signBillResp) || 'Unable to sign Encounter'
                brToastError(errorMsg)
              }
            } else {
              brToastError('Encounter and Note cannot be signed')
            }
          } else {
            brToastError(findErrorMsg(res) || 'Error while saving Progress Note')
          }
        } catch (e) {
          setIsLoading(false)
          brToastError(findErrorMsg(e) || 'Error while saving and signing')
        }
      }
    }
  }

  const onPendingReview = async () => {
    if (quary?.id) {
      setIsLoading(true)
      const url = COLLECTOR_URL.SET_PENDING_REVIEW.replace('{visit_id}', quary?.id)
      let data = {
        visit_id: quary?.id,
      }
      const res = await putCollector(url, data)
      setIsLoading(false)
      if (res?.status === 'success') {
        navigate('/census')
      } else {
        console.error(res)
      }
    }
  }

  const onBillingSave = (isPendingReview) => {
    if (quary?.id) {
      saveBillingNotes(quary?.id, { billing_notes: billingTxt })
    }

    if (onSaveDraft) {
      if (getIsAi() && features?.includes(FEATURES.DesktopAI)) {
        dispatch(getAiPredictions())
      }
      onSaveDraft(null, { isPendingReview })
    }
  }

  const goBackHandle = async (saveAsDraft = false) => {
    setBackConfirm(false)
    if (saveAsDraft) {
      await onSaveDraft(null)
    }
    goBackNavigation(navigate, previousState?.state?.previousPage)
  }

  const patientDOB =
    visitDetails?.patient_dob && visitDetails?.patient_dob !== 'Invalid date'
      ? dateUSFormat(visitDetails?.patient_dob)
      : ''

  return (
    <div className="progress-note-page">
      {(isloading || isLoading) && <Loader />}
      {backConfirm && (
        <GenericConfirmModal
          onCancelButton={() => goBackHandle(false)}
          onClose={() => {
            setBackConfirm(false)
          }}
          onConfirm={() => goBackHandle(true)}
          title={'Save as Draft?'}
          content={'You have unsaved changes. Do you want to save them as a draft?'}
        />
      )}
      {showAsteriskWarningModal && (
        <AsteriskConfirm
          onConfirm={() => {
            setShowAsteriskWarningModal(false)
            onSignAndBill({ ignoreAsteriskWarning: true })
          }}
          handleClose={() => setShowAsteriskWarningModal(false)}
        />
      )}
      <CContainer>
        <div className="note-page-header">
          <CRow
            className={`progress-page-head align-items-center justify-content-between census-page-title-container`}
            style={{ paddingBottom: '50px' }}
          >
            <CCol xs="12" className="census-page-title">
              <CRow>
                <CCol md={4}>
                  <div className="heading-holder">
                    <div
                      className="icon-holder"
                      onClick={() => (isDraftSaved ? goBackHandle() : setBackConfirm(true))}
                    >
                      <i className="fa-light fa-arrow-left-long fa-xs icon"></i>
                    </div>
                    {visitDetails ? (
                      <>
                        <div className="name">
                          {visitDetails?.patient_lastname &&
                            _.capitalize(visitDetails?.patient_lastname)}
                          , &nbsp;
                          {visitDetails?.patient_firstname &&
                            _.capitalize(visitDetails?.patient_firstname)}
                        </div>
                        <div className="dob">
                          {patientDOB} &nbsp;&nbsp;
                          {patientDOB ? getAge(visitDetails?.patient_dob) : ''} yrs{' '}
                          {`(${visitDetails?.gender})`}
                        </div>
                      </>
                    ) : (
                      'Progress Note'
                    )}
                  </div>
                </CCol>
                <CCol md={4}>
                  <div className="heading-holder">
                    <div className="location">
                      <>
                        {visitDetails?.facility_name || ''} &nbsp;&nbsp;
                        {visitDetails?.room ? ' | ' + visitDetails?.room : '-'}{' '}
                      </>
                    </div>
                  </div>
                </CCol>
                <CCol md={4}>
                  <div className="type-holder heading-holder">
                    <div className="title">Encounter Type:</div>
                    <CNav variant="pills" layout="fill">
                      <CNavItem>
                        <CNavLink
                          active={encounterType === ENCOUNTER_TYPES.INITIAL}
                          onClick={() => {
                            setEncounterType(ENCOUNTER_TYPES.INITIAL)
                          }}
                        >
                          Initial
                        </CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink
                          active={encounterType === ENCOUNTER_TYPES.SUBSEQUENT}
                          onClick={() => {
                            setEncounterType(ENCOUNTER_TYPES.SUBSEQUENT)
                          }}
                        >
                          Subsequent
                        </CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink
                          active={encounterType === ENCOUNTER_TYPES.DISCHARGE}
                          onClick={() => {
                            setEncounterType(ENCOUNTER_TYPES.DISCHARGE)
                          }}
                        >
                          Discharge
                        </CNavLink>
                      </CNavItem>
                      <CNavItem>
                        <CNavLink
                          active={encounterType === ENCOUNTER_TYPES.OTHER}
                          onClick={() => {
                            setEncounterType(ENCOUNTER_TYPES.OTHER)
                          }}
                        >
                          Other
                        </CNavLink>
                      </CNavItem>
                    </CNav>
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>

        <CRow>
          <CCol lg={7}>
            <div className="static-container mt-3">
              <div className="main-tab-holder">
                <div
                  className="main-tab-holder"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${mainTab === 1 ? 'active' : ''} `}
                        aria-current="page"
                        onClick={() => {
                          onBillingSave()
                          setMainTab(1)
                        }}
                      >
                        Progress note
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${mainTab === 2 ? 'active' : ''}`}
                        onClick={() => setMainTab(2)}
                      >
                        Billing summary
                      </button>
                    </li>
                  </ul>
                  {mainTab === 1 && canUseDragon && <DragonController />}
                </div>
              </div>
              {mainTab === 1 && (
                <CCard>
                  <CCardBody className={'progNote-card-body'}>
                    <div className="progress-note-wraper">
                      <div className="progress-holder">
                        <div className="note-header">
                          {visitDetails && (
                            <div className="header-row">
                              <div className="head-col">
                                <p>SERVICE DATE: {dateOfService || ' '}</p>
                                <p>
                                  PATIENT: {visitDetails?.patient_name || ''}{' '}
                                  {`(${visitDetails?.gender} | ${patientDOB} | ${getAge(
                                    visitDetails?.patient_dob,
                                    dateOfService,
                                  )} y/o)`}
                                </p>
                                <p>FACILITY: {selectedFacilityName || ''}</p>
                              </div>

                              <div className="head-col">
                                <p>
                                  {' '}
                                  {provider?.organization_name ? provider?.organization_name : ''}
                                </p>
                                <p>{provider?.phone ? provider?.phone : ''}</p>
                              </div>
                            </div>
                          )}
                          {visitDetails && selectedTemplate?.title_print && (
                            <center>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: selectedTemplate?.title_print,
                                }}
                                className="note-title-txt"
                              ></div>
                            </center>
                          )}
                        </div>
                        <div className="note-body">
                          <div className="note-section-holder" key={templateData?.length}>
                            <div className="note-section">
                              {templateData?.map((section, index) => {
                                let selectedSec = selectedSections?.find(
                                  (sec) =>
                                    sec?.title === section?.title &&
                                    sec?.title !== 'Diagnosis (ICD10)' &&
                                    sec?.title !== 'E&M and procedure codes',
                                )
                                return (
                                  <React.Fragment key={section?.title + ' fragment'}>
                                    {selectedSec && (
                                      <DynamicSection
                                        section={selectedSec}
                                        key={section?.title + index}
                                        activeSectionHandle={(section) => {
                                          dispatch(setActiveSection(section))
                                        }}
                                        isTyping={isTyping}
                                        setIsTyping={setIsTyping}
                                        isDraftSaved={isDraftSaved}
                                        setIsDraftSaved={setIsDraftSaved}
                                        currentTab={currentTab}
                                        setCurrentTab={setCurrentTab}
                                        snippets={snippetList || []}
                                        onSaveDraft={() => {
                                          if (!isFirstAutoFocusSave) {
                                            // we do not want the user to open the note,
                                            // and have it auto-save
                                            onSaveDraft()
                                          } else {
                                            setIsFirstAutoFocusSave(false)
                                          }
                                        }}
                                      />
                                    )}
                                  </React.Fragment>
                                )
                              })}
                            </div>
                          </div>
                        </div>

                        <div className="note-footer">
                          <ProgressNoteActionButtons
                            SignButton={() => (
                              <CButton
                                className="progress-note-billing-summary-dropdown-main"
                                color="primary"
                                onClick={onSignAndBill}
                                disabled={
                                  practice?.medical_coding &&
                                  provider?.medical_coding !== false &&
                                  !roles.includes('Claimocity App Biller')
                                    ? false
                                    : !isValidToSign
                                }
                              >
                                {provider?.medical_coding ? 'Sign Note' : 'Sign and bill'}
                              </CButton>
                            )}
                            SaveButton={() => (
                              <CDropdownItem
                                className="progress-note-billing-summary-item progress-note-billing-summary-item-draft"
                                onClick={() => onSaveDraft()}
                              >
                                <div className="progress-note-billing-summary-item-text">
                                  Save as draft
                                </div>
                              </CDropdownItem>
                            )}
                            PendingReviewButton={() => (
                              <CDropdownItem
                                className="progress-note-billing-summary-item progress-note-billing-summary-item-pending-review"
                                onClick={() => {
                                  onSaveDraft(null, { isPendingReview: true })
                                }}
                              >
                                <div className="progress-note-billing-summary-item-text">
                                  Pending review
                                </div>
                              </CDropdownItem>
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </CCardBody>
                </CCard>
              )}

              {mainTab === 2 && (
                <>
                  {visitDetails?.status !== VISIT_STATUS.bill_submitted ? (
                    <BillingSummary
                      allFacilites={allFacilities}
                      onBillingSave={onBillingSave}
                      onSignAndBill={onSignAndBill}
                      visit={visitDetails}
                      encounterType={encounterType}
                      setBillingTxt={setBillingTxt}
                      billingTxt={billingTxt}
                      selectedSharedProvider={selectedSharedProvider}
                      setSelectedSharedProvider={setSelectedSharedProvider}
                      incidentToProviderSubstantive={incidentToProviderSubstantive}
                      setIncidentToProviderSubstantive={setIncidentToProviderSubstantive}
                      isTeleHealth={isTelehealth}
                      setIsTeleHealth={setIsTelehealth}
                      isCareCoordination={isCareCoordination}
                      setIsCareCoordination={setIsCareCoordination}
                      isLongTermCare={isLongTermCare}
                      setIsLongTermCare={setIsLongTermCare}
                      isNeuroSuite={isNeuroSuite}
                      setIsNeuroSuite={setIsNeuroSuite}
                      isPendingCosign={isPendingCosign}
                      setIsPendingCosign={setIsPendingCosign}
                      authNumber={authNumber}
                      setAuthNumber={setAuthNumber}
                      isHospiceRelated={isHospiceRelated}
                      setIsHospiceRelated={setIsHospiceRelated}
                      setBillingEntity={setBillingEntity}
                      billingEntity={billingEntity}
                      billingEntityOptions={provider?.legal_entities || []}
                      selectedPlaceOfService={selectedPlaceOfService}
                      setSelectedPlaceOfService={setSelectedPlaceOfService}
                      careTeam={careTeam}
                      setCareTeam={setCareTeam}
                      isValidToSign={isValidToSign}
                      dateOfService={dateOfService}
                      setDateOfService={(newDOS) => {
                        setDateOfService(newDOS)
                        setChangedDOS(true)
                      }}
                      selectedFacilityID={selectedFacilityID}
                      setSelectedFacilityID={setSelectedFacilityID}
                      setSelectedFacilityName={setSelectedFacilityName}
                    />
                  ) : (
                    <BillingSummaryDisabled
                      onSaveDraft={onSaveDraft}
                      onSignAndBill={onSignAndBill}
                      visit={visitDetails}
                      isValidToSign={isValidToSign}
                    />
                  )}
                </>
              )}
            </div>
          </CCol>
          <CCol lg={5}>
            {mainTab === 1 && (
              <CCard className="mt-3 template-container">
                <CCardBody>
                  <div className="filter-main-holder">
                    <div className="filter-holder">
                      <div className="filter-header">
                        <CNav variant="pills" layout="fill">
                          <CNavItem>
                            <CNavLink
                              active={currentTab === TAB_OPTIONS.SECTION}
                              onClick={() => setCurrentTab(TAB_OPTIONS.SECTION)}
                            >
                              Sections
                            </CNavLink>
                          </CNavItem>
                          <CNavItem>
                            <CNavLink
                              active={currentTab === TAB_OPTIONS.TEMPLATE}
                              onClick={() => setCurrentTab(TAB_OPTIONS.TEMPLATE)}
                            >
                              Template(s)
                            </CNavLink>
                          </CNavItem>
                          <CNavItem>
                            <CNavLink
                              active={currentTab === TAB_OPTIONS.SNIPPET}
                              onClick={() => {
                                setCurrentTab(TAB_OPTIONS.SNIPPET)
                              }}
                            >
                              Snippets
                            </CNavLink>
                          </CNavItem>
                          <CNavItem>
                            <CNavLink
                              active={currentTab === TAB_OPTIONS.RECENTNOTES}
                              onClick={() => {
                                setCurrentTab(TAB_OPTIONS.RECENTNOTES)
                              }}
                            >
                              Recent Notes
                            </CNavLink>
                          </CNavItem>
                          {visitDetails?.points_click_care_patient && (
                            <CNavItem>
                              <CNavLink
                                active={currentTab === TAB_OPTIONS.LABS}
                                onClick={() => {
                                  setCurrentTab(TAB_OPTIONS.LABS)
                                }}
                              >
                                Labs
                              </CNavLink>
                            </CNavItem>
                          )}
                        </CNav>
                      </div>
                      <div className="filter-tab">
                        <div className="tab-body">
                          {currentTab === TAB_OPTIONS.SECTION && (
                            <>
                              <div className="all-select-check-box">
                                <CFormCheck
                                  id={`select-all`}
                                  label={`Select all`}
                                  onChange={selectAllSection}
                                  checked={selectedSections?.length === templateData?.length}
                                />
                              </div>
                              <div className="filter-holder">
                                <>
                                  {templateData?.map((section, index) => {
                                    let isChecked = selectedSections.find(
                                      (item) => item?.title === section?.title,
                                    )

                                    return (
                                      section?.title !== 'Diagnosis (ICD10)' &&
                                      section?.title !== 'E&M and procedure codes' && (
                                        <DynamicSectionFilter
                                          key={'DynamicSectionFilter' + index}
                                          section={section}
                                          isChecked={Boolean(isChecked)}
                                          addSelectedSection={addSelectedSection}
                                          removeSelectedSection={removeSelectedSection}
                                        />
                                      )
                                    )
                                  })}
                                </>
                              </div>
                            </>
                          )}
                          {currentTab === TAB_OPTIONS.TEMPLATE && (
                            <>
                              {activeSection && (
                                <DynamicTemplates
                                  onTemplateFill={onTemplateFill}
                                  onDataChange={onDataChange}
                                  section={templateData?.find(
                                    (section) => section?.title === activeSection?.title,
                                  )}
                                  setIsTyping={setIsTyping}
                                  // patient details are stuck inside the visit
                                  patient={visitDetails}
                                />
                              )}
                            </>
                          )}
                          {currentTab === TAB_OPTIONS.SNIPPET && (
                            <div className="filter-holder">
                              <SnippetSection
                                snippetList={snippetList || []}
                                setSnippetList={setSnippetList}
                                onDeleteSnippet={onDeleteSnippet}
                                setIsTyping={setIsTyping}
                                setIsDraftSaved={setIsDraftSaved}
                                section={templateData?.find(
                                  (section) => section?.title === activeSection?.title,
                                )}
                                getSnips={getSnips}
                              />
                            </div>
                          )}
                          {currentTab === TAB_OPTIONS.RECENTNOTES && (
                            <div className="filter-holder">
                              <RecentNoteSection />
                            </div>
                          )}
                          {currentTab === TAB_OPTIONS.LABS &&
                            visitDetails?.points_click_care_patient && (
                              <div className="filter-holder">
                                <LabPreview />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </CCardBody>
              </CCard>
            )}

            {mainTab === 2 && (
              <>
                <SherpaAI
                  visit={visitDetails}
                  onBillingSave={onBillingSave}
                  allFacilites={allFacilities}
                  onSignAndBill={onSignAndBill}
                  setBillingTxt={setBillingTxt}
                  billingTxt={billingTxt}
                  selectedSharedProvider={selectedSharedProvider}
                  setSelectedSharedProvider={setSelectedSharedProvider}
                  incidentToProviderSubstantive={incidentToProviderSubstantive}
                  setIncidentToProviderSubstantive={setIncidentToProviderSubstantive}
                  isTeleHealth={isTelehealth}
                  setIsTeleHealth={setIsTelehealth}
                  isCareCoordination={isCareCoordination}
                  setIsCareCoordination={setIsCareCoordination}
                  isNeuroSuite={isNeuroSuite}
                  setIsNeuroSuite={setIsNeuroSuite}
                  isPendingCosign={isPendingCosign}
                  setIsPendingCosign={setIsPendingCosign}
                  authNumber={authNumber}
                  setAuthNumber={setAuthNumber}
                  selectedPlaceOfService={selectedPlaceOfService}
                  isValidToSign={isValidToSign}
                  careTeam={careTeam}
                  setCareTeam={setCareTeam}
                  isHospiceRelated={isHospiceRelated}
                  setIsHospiceRelated={setIsHospiceRelated}
                />
              </>
            )}
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}
